import { Component } from "@angular/core";

@Component({
	selector: "community",
	templateUrl: "./brokerage.html",
	styleUrls: ["./brokerage.scss"],
})
export class BrokerageComponent { }



// WEBPACK FOOTER //
// ./Frontend/src/app/components/home/brokerage/brokerage.ts